import loadable from '@loadable/component';
import { createFileRoute } from '@tanstack/react-router';
import { RouteName, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';

const EnterpriseIntegrationCreate = loadable(async () =>
    import(
        /* webpackChunkName: "enterpriseIntegrationCreate" */ '@mews-commander/enterprise-integration/EnterpriseIntegrationCreateContainer'
    ).then((module) => module.EnterpriseIntegrationCreateContainer)
);

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/EnterpriseIntegration/Create/$integrationDataId/$targetEnterpriseId'
)({
    component: Component,
    staticData: {
        title: TextKey.Settings,
        routeName: RouteName.EnterpriseIntegrationCreate,
        owner: MewsTeam.ActivationExperience,
        type: RouteType.Frontend,
    },
});

function Component() {
    const { integrationDataId, targetEnterpriseId } = Route.useParams();

    return (
        <EnterpriseIntegrationCreate integrationDataId={integrationDataId} targetEnterpriseId={targetEnterpriseId} />
    );
}
